import Http from '../Core/Http';
export default class My extends Http {
  constructor(config) {
    super(config);
  }
  //用户Login/GetSessionId
  GetSessionId() {
    return this._get('/api/Login/GetSessionId')
  }

  QueryUser(sessionId) {
    return this._get('/api/user/QueryUser', {
      sessionId: sessionId
    });
  }

  //缴费记录GET/api/Bill/GetPaymentRecordList
  GetpaymentRecordlistV2(params) {
    return this._get('/api/Bill/GetpaymentRecordlistV2', params);
  }

  //住院预缴列表POST/api/Interaction/GetPrepayList
  GetPrepayList(data) {
    return this._post('/api/Interaction/GetPrepayList', null, data);
  }

  //获取住院费用查询-分类汇总POST/api/Interaction/GetInpatientExpensesGroupByCategory
  GetExpensesGroupByCategoryV2(data) {
    return this._post('/api/Interaction/GetExpensesGroupByCategoryV2', null, data);
  }

  //获取住院费用查询---每日清单明细POST/api/Interaction/GetExpensesDetails
  GetInpatientFeeByDay(data) {
    return this._post('/api/Interaction/GetInpatientFeeByDay', null, data);
  }

  //病人在院基本信息查询post、GetHospitalizationInfo
  GetHospitalizationInfo(data) {
    return this._post('/api/Interaction/GetHospitalizationInfo', null, data);
  }

  //获取检查报告列表POST//api/Interaction/GetInspectionReportList
  GetInspectionReportList(data) {
    return this._post('/api/Interaction/GetInspectionReportList', null, data);
  }

  //获取检查报告详情/api/Interaction/GetInspectionReport
  GetInspectionReport(data) {
    return this._post('/api/Interaction/GetInspectionReport', null,data);
  }

  //获取检验报告列表POST/api/Interaction/GetLaboratoryReportListV2
  GetLaboratoryReportListV2(data) {
    return this._post('/api/Interaction/GetLaboratoryReportListV2', null, data);
  }

  //获取检验报告详情POST/api/Interaction/GetLaboratoryReport
  GetLaboratoryReport(data) {
    return this._post('/api/Interaction/GetLaboratoryReport', null, data);
  }
// 获取体检报告列表
GetExaminationReportList(data){
  return this._post('api/Interaction/GetExaminationReportList',null,data)
}
// 获取体检报告详情
GetExaminationReportDetail(data){
  return this._post('api/Interaction/GetExaminationReportDetail',null,data)
}
   // 健康卡绑定验证接口,微信电子健康卡
   IsHealthCardExists(data) {
    return this._post('/api/ehc/IsHealthCardExists', null, data);
  }
 // 健康卡绑定验证接口,从his判断是否存在用户信息
 HisIsHealthCardExists(data) {
  return this._post('/api/Interaction/IsHealthCardExists', null, data);
}

  // 添加健康卡
  AddHealthCardInfo(data) {
    return this._post('/api/HealthCard/Add', null, data);
  }

  // 获取绑定得健康卡
  GetBindHealthCard(id) {
    return this._get('/api/ehc/GetBindHealthCard', {
      userId: id
    });
  }

  // 在线建档
  OnlineFile(data) {
    return this._post('/api/Interaction/OnlineFile', null, data);
  }

  // 删除健康卡
  DelHealthCardInfo(id) {
    return this._get('/api/HealthCard/Delete', {
      id: id
    });
  }
  GetUserInfo(data){
    return this._post('/api/interaction/GetUserInfo',null,data)
  }
  GetData(data){
    return this._post('/api/interaction/GetData',null,data)
  }
  GetWxConfig(params){
    return this._get(`/api/login/GetSysConfig`,params);
  }
  // ocr识别返回用户信息
  GetPatientInfo(data){
    return this._post('/api/ehc/GetPatientInfo', null, data);
  }
  // 查询当前卡片信息
  QueryCardInfo(data){
    return this._post('/api/ehc/QueryCardInfo', null, data);
  }
  // 获取人脸识别所需orderid
  GetFaceOrder(data){
    return this._post('/api/ehc/GetFaceOrder', null, data);

  }
  // 校验人脸识别数据
  CheckFaceResult(data){
    return this._post('/api/ehc/CheckFaceResult', null, data);

  }
  // 微信注册
  RegisterCard(data){
    return this._post('/api/ehc/RegisterCard', null, data);

  }
  // 关联院内与微信电子健康卡
  BindHealthCard(data){
    return this._post('/api/ehc/BindHealthCard', null, data);
  }
  //获取code
  GetCardQRCode(data){
    return this._post('/api/ehc/GetCardQRCode', null, data);

  }
  // 获取微信卡包所需orderId
  GetPackageOrder(data){
    return this._post('/api/ehc/GetPackageOrder', null, data);

  }
   // 微信电子健康卡解绑
   UnBindWeChatEhc(data){
    return this._post('/api/ehc/Unbind', null,data);
  }
 //  设置默认健康卡
 SetDefaultCard(params){
  return this._get('/api/User/SetDefaultHealthCard', params);
}
ClearCookie(){
  return this._get("/api/login/ClearCookie")
}
// 获取院内满意度调查表
GetSurvey(params) {
  return this._get('/api/CustomerInvestigate/GetTemplate', params, null);
}
// 保存院内满意度调查表
SaveSurvey(data) {
  return this._post('/api/CustomerInvestigate/SaveInvestigate', null, data);
}
}



// WEBPACK FOOTER //
// ./src/lib/PMA/My.js